import React from 'react';

const ToggleVisibleBtn = (props) => (
  <span className="span-visible-toggle-icon"
    style={props.style}
    onClick={props.onClick}>
  </span>
);


export default ToggleVisibleBtn;


// WEBPACK FOOTER //
// ./src/commonComponents/ToggleVisibleBtn.jsx